module.exports = __webpack_public_path__ + "img/brolly.a45118a9.png";